module.exports = __webpack_public_path__ + "media/images/lb/007-c7154db5696d2beda889bcaa10e969c0.svg";